import { roundTo } from "components/utils/mathUtils";

export const COMPANY_NAME = "Solar Valley";
export const PHONE_NUMBER = "35152004";
export const WHATSAPP_NUMBER = "55915842";
export const EMAIL_ADDRESS = "info@solarvalley.com";

const formatGwPhone = (num) => `+502 ${num.substring(0, 4)}-${num.substring(4, 8)}`;

export const CALL_PHONE_NUMBER = `+502${PHONE_NUMBER}`;
export const PHONE_NUMBER_FORM = formatGwPhone(PHONE_NUMBER);

export const WHATSAPP_NUMBER_CHAT = `+502${WHATSAPP_NUMBER}`;
export const WHATSAPP_NUMBER_FORM = formatGwPhone(WHATSAPP_NUMBER);

export const GARANTY_YEARS = 25; //Garantía de los paneles
export const PLANTAS_SOLARES = 50; //Plantas existentes
export const REDUCE_FACT = 90; //Porcentaje esperado o reducción de factura en %
export const MIN_PORCENT_FACT = 80; //Porcentaje mínimo de pago de la factura en %
export const SATISFACTION_CLIENT = 90; //Satisfaccion de los clientes promedio en %
export const INICIO_DESDE = 2023;

export const AHORRO_PROMEDIO = 85; //Ahorro promedio ofrecido
export const MAX_PANELES_POR_SISTEMA = 24; //Maximo de paneles actaules
export const KWH_MES_PANEL = 80; //kW que genera un panel por mes
export const KWH_DIA_PANEL = 2.67; //kW que genera un panel por dia
export const COSTO_ENERGIA_PROM_SINPANEL = 1.41; //Costo de la energía sin panel
export const COSTO_ENERGIA_PROM_CONPANEL = 1.1; //Costo de la energía ya con panel
export const PORCENTAJE_PAGO_FIJO = 30; //Porcentaje que se paga de la factura fija en %
export const DESCUENTO_CONTADO = 10; //Descuento por pagar al contado en %
export const TASA_INTERES = 8; //Tasa de interes por financiamiento en %
export const FACT_CO2_PROMEDIO_ANUAL = 0.000475; //Factor promedio en kg de CO2 por kwh
export const FACT_CARBON_PROM_ANUAL = 0.842; //Factor de Carbon por CO2 en kg
export const FACT_ARBOLES_PROM_ANUAL = 1.366; //promedio de CO2 absorbido por un árbol por año en kg
export const FACT_CARS_OFF_PROM_ANUAL = 4600; //Equivalente a autos fuera de circulación en kg de CO2 al año
export const CALIFICACION_PROMEDIO = 4.8; //Calificación sobre 5

export const ENERGIA_TOTAL = 163284490; //Energía generada actual en kw
export const AHORRO_TOTAL = 15420000; //Ahorro obtenido actual
export const CO2_TOTAL = roundTo(ENERGIA_TOTAL * FACT_CO2_PROMEDIO_ANUAL, 2); //CO2 evitado actual en kg
export const CARBON_TOTAL = roundTo(CO2_TOTAL * FACT_CARBON_PROM_ANUAL, 2); //Carbon evitado actual en kg
export const TOTAL_ARBOLES = roundTo(
  (CO2_TOTAL / 1000) * FACT_ARBOLES_PROM_ANUAL,
  0
); //Arboles plantados actual
export const CARS_OFF_TOTAL = roundTo(CO2_TOTAL / FACT_CARS_OFF_PROM_ANUAL, 0); //Autos fuera de circulación actual

export const guatemalaRegions = [
  {
    id: "regionI",
    name: "Región Metropolitana",
    label: "Guatemala",
    solarPotential: "5.2 kWh/m²/día",
    savings: "Q2,400",
    coordinates: { x: "44%", y: "81%" },
    porcentaje: 100,
  },
  {
    id: "regionII",
    name: "Región Norte",
    label: "Baja Verapaz, Alta Verapaz",
    solarPotential: "5.8 kWh/m²/día",
    savings: "Q2,800",
    coordinates: { x: "45%", y: "54%" },
    porcentaje: 112, // (5.8 / 5.2) * 100 ≈ 112%
  },
  {
    id: "regionIII",
    name: "Región Nororiente",
    label: "El Progreso, Izabal, Zacapa, Chiquimula",
    solarPotential: "5.5 kWh/m²/día",
    savings: "Q2,600",
    coordinates: { x: "67%", y: "71%" },
    porcentaje: 106, // (5.5 / 5.2) * 100 ≈ 106%
  },
  {
    id: "regionIV",
    name: "Región Suroriente",
    label: "Santa Rosa, Jalapa, Jutiapa",
    solarPotential: "5.9 kWh/m²/día",
    savings: "Q2,900",
    coordinates: { x: "50%", y: "90%" },
    porcentaje: 113, // (5.9 / 5.2) * 100 ≈ 113%
  },
  {
    id: "regionV",
    name: "Región Central",
    label: "Sacatepéquez, Chimaltenango, Escuintla",
    solarPotential: "6.5 kWh/m²/día",
    savings: "Q3,500",
    coordinates: { x: "34%", y: "79%" },
    porcentaje: 125, // (6.5 / 5.2) * 100 ≈ 125%
  },
  {
    id: "regionVI",
    name: "Región Suroccidente",
    label:
      "Sololá, Totonicapán, Quetzaltenango, Suchitepéquez, Retalhuleu, San Marcos",
    solarPotential: "6.0 kWh/m²/día",
    savings: "Q3,100",
    coordinates: { x: "12%", y: "69%" },
    porcentaje: 115, // (6.0 / 5.2) * 100 ≈ 115%
  },
  {
    id: "regionVII",
    name: "Región Noroccidente",
    label: "Huehuetenango, Quiché",
    solarPotential: "5.0 kWh/m²/día",
    savings: "Q2,300",
    coordinates: { x: "30%", y: "50%" },
    porcentaje: 96, // (5.0 / 5.2) * 100 ≈ 96%
  },
  {
    id: "regionVIII",
    name: "Región Petén",
    label: "Petén",
    solarPotential: "6.2 kWh/m²/día",
    savings: "Q3,200",
    coordinates: { x: "50%", y: "25%" },
    porcentaje: 119, // (6.2 / 5.2) * 100 ≈ 119%
  },
];

export const paneles_solares = [
  {
    paneles: 24,
    inversion: 92208.76,
  },
  {
    paneles: 22,
    inversion: 86748.24,
  },
  {
    paneles: 21,
    inversion: 84017.98,
  },
  {
    paneles: 20,
    inversion: 81287.72,
  },
  {
    paneles: 19,
    inversion: 78557.46,
  },
  {
    paneles: 18,
    inversion: 75031.26,
  },
  {
    paneles: 17,
    inversion: 72301.0,
  },
  {
    paneles: 16,
    inversion: 69570.74,
  },
  {
    paneles: 15,
    inversion: 66840.48,
  },
  {
    paneles: 14,
    inversion: 64110.22,
  },
  {
    paneles: 13,
    inversion: 60093.49,
  },
  {
    paneles: 12,
    inversion: 57363.23,
  },
  {
    paneles: 11,
    inversion: 53698.21,
  },
  {
    paneles: 10,
    inversion: 50967.95,
  },
  {
    paneles: 9,
    inversion: 48524.59,
  },
  {
    paneles: 8,
    inversion: 45794.33,
  },
  {
    paneles: 7,
    inversion: 38899.27,
  },
  {
    paneles: 6,
    inversion: 35659.98,
  },
  {
    paneles: 5,
    inversion: 29227.67,
  },
  {
    paneles: 4,
    inversion: 17800.0,
  },
  {
    paneles: 3,
    inversion: 13350,
  },
  {
    paneles: 2,
    inversion: 8000,
  },
  {
    paneles: 1,
    inversion: 5000,
  },
];
